exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.identity[data-v-1a2256fc] {\n  display: block;\n  text-align: center;\n}\n.user[data-v-1a2256fc] {\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  margin: auto;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n.dfinity img[data-v-1a2256fc] {\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  margin: auto;\n  cursor: pointer;\n}\n", ""]);

// exports
